import * as React from 'react';
import { RoleManagement } from '../components/RoleManagement';
import { mockRoles } from '../data/mock-users';
import { RolePermission } from '../types';
import { PageHeader } from '@/components/layout/PageHeader';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

export function UserRolesPage() {
  const [roles, setRoles] = React.useState(mockRoles);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleUpdateRole = (roleId: string, permissions: RolePermission[]) => {
    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      console.log('Updating role permissions:', roleId, permissions);
      
      // Update the roles state with the new permissions
      setRoles(roles.map(role => 
        role.id === roleId 
          ? { ...role, permissions } 
          : role
      ));
      
      toast.success('Role permissions updated successfully');
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="User Roles"
        description="Manage role-based permissions for system users."
      />
      
      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Administrator Access</AlertTitle>
        <AlertDescription>
          Changes to role permissions affect all users with the selected role. Some system role permissions cannot be modified.
        </AlertDescription>
      </Alert>
      
      <RoleManagement 
        roles={roles} 
        onUpdateRole={handleUpdateRole} 
        isLoading={isLoading} 
      />
    </div>
  );
}
